import { c as _c } from "react/compiler-runtime";
import { RefObject, useEffect, useState } from 'react';
import { dispatchHeroReady } from '@/hooks/useLoader';
const HAVE_CURRENT_DATA = 2;
const HERO_MEDIA_TIMEOUT_MS = 2500;
const waitForVideo = (video: HTMLVideoElement) => {
  if (video.readyState >= HAVE_CURRENT_DATA) return Promise.resolve();
  return new Promise<void>(resolve => {
    const onReady = () => resolve();
    video.addEventListener('canplay', onReady, {
      once: true
    });
    video.addEventListener('error', onReady, {
      once: true
    });
  });
};
const waitForImage = (image: HTMLImageElement) => {
  if (image.complete) return Promise.resolve();
  return new Promise<void>(resolve => {
    const onReady = () => resolve();
    image.addEventListener('load', onReady, {
      once: true
    });
    image.addEventListener('error', onReady, {
      once: true
    });
  });
};
interface Params {
  wrapperRef: RefObject<HTMLDivElement | null>;
  loaderRef: RefObject<HTMLDivElement | null>;
  flashRef: RefObject<HTMLImageElement | null>;
  flashMountKey: number;
}
export function useHeroMediaReady(t0) {
  const $ = _c(9);
  const {
    wrapperRef,
    loaderRef,
    flashRef,
    flashMountKey
  } = t0;
  const [isHeroReady, setIsHeroReady] = useState(false);
  let t1;
  if ($[0] !== flashRef || $[1] !== loaderRef || $[2] !== wrapperRef) {
    t1 = () => {
      const loaderVideo = loaderRef.current?.querySelector("video");
      const heroVideo = wrapperRef.current?.querySelector("[data-hero-media=\"chub\"]");
      const flash = flashRef.current;
      const tasks = [loaderVideo ? waitForVideo(loaderVideo) : null, heroVideo ? waitForVideo(heroVideo) : null, flash ? waitForImage(flash) : null].filter(Boolean) as Promise<void>[];
      let cancelled = false;
      let didMark = false;
      const markReady = () => {
        if (cancelled || didMark) {
          return;
        }
        didMark = true;
        window.clearTimeout(timeoutId);
        setIsHeroReady(true);
        dispatchHeroReady();
      };
      const timeoutId = window.setTimeout(markReady, HERO_MEDIA_TIMEOUT_MS);
      const waitForHeroMedia = async () => {
        if (tasks.length) {
          await Promise.all(tasks);
        }
        markReady();
      };
      waitForHeroMedia();
      return () => {
        cancelled = true;
        window.clearTimeout(timeoutId);
      };
    };
    $[0] = flashRef;
    $[1] = loaderRef;
    $[2] = wrapperRef;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== flashMountKey || $[5] !== flashRef || $[6] !== loaderRef || $[7] !== wrapperRef) {
    t2 = [wrapperRef, loaderRef, flashRef, flashMountKey];
    $[4] = flashMountKey;
    $[5] = flashRef;
    $[6] = loaderRef;
    $[7] = wrapperRef;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  return isHeroReady;
}